import styled from 'styled-components'
import Flex from 'Components/Flex'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import { LIGHT_BACKGROUND } from '@CSSVars/colors'


export const _InnerContainerFlex = styled(Flex)`
  width: 100%;
  position: relative;
  display: flex;
  align-items: start;
  overflow-x: hidden;
`

export const _CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px;

  background-color: ${LIGHT_BACKGROUND};
  border-radius: 10px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    height: 122px;
    padding: 12px 12px 8px 9px;
    overflow: hidden;
  }

`

export const _PreconListing = styled(AppLinkMobileCtrl)`
  display: block;
  margin-bottom: 12px;
  /*next line is for print listing page to avoid breaking cards*/
  break-inside: avoid;
  &:hover {
    cursor: pointer;
  }

  &:last-child {
    margin-bottom: 0;
  }
`


export const _ListingImg = styled(AppLinkMobileCtrl)`
  & div:first-of-type {
    display: flex;
    min-height: 100%;
    min-width: 100%;
    background-size: cover;
    width: 70px;
    height: 70px;
    border-radius: 10px;
  }

  img {
    transform: translate(-50%, -50%);
    position: relative;
    left: 50%;
    top: 50%;
    flex: 1;
    height: 100%;
    width: auto;
    background-size: cover;
  }

  background-size: cover;

  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    > div {
      width: 70px !important;
      height: 70px !important;
    }
  }

  @media screen and (max-width: 350px) {
    display: none;
  }


`
